import { css } from 'bumbag';
import { _ as _taggedTemplateLiteralLoose } from './_rollupPluginBabelHelpers.js';

var _templateObject;
var Link = {
  styles: {
    base: css(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n      text-decoration: underline;\n    "])))
  }
};

export default Link;
